export const AGE_REQUIRED = 16 // year
export const CONNECT_ACCOUNT_TRESHOLD = 60 // minutes
export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 20
